














































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/shang/promotion/coupon`,
  coupon: `${FCAPI}/shang/promotion/coupon/record`,
  status: `${FCAPI}/shang/promotion/coupon/status`,
};

@Component
export default class EditFirst extends Vue {
  is_loading: boolean = false;

  form: any = {
    name: '',
    type: '0',
    status: '0',
  };
  page: number = 1;
  table_data: any = {};
  is_show_received_modal: boolean = false;
  is_show_used_modal: boolean = false;
  is_show_qrcode_modal: boolean = false;
  is_show_status_modal: boolean = false;
  received_item: any = {};
  used_item: any = {};
  received_data: any = {
    detail: [],
  };
  used_data: any = {
    detail: [],
  };
  qrcode: string = '';
  status_text: string = '';
  send_data: any = {};
  status_item: any = {};

  handChangePaging(pagination: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  handChangePagingModal(pagination: any) {
    const next_page = pagination.current;
    this.getCouponList(next_page);
  }

  paginationOption(data: FcapiRemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  async submit() {
    await this.query();
  }

  addCoupon() {
    this.$router.push('/promotion/coupon/config-first');
  }

  clearForm() {
    this.form = {
      name: '',
      type: '0',
      status: '0',
    };
  }

  async showREceivedModal(item: any) {
    this.received_item = item;
    this.is_show_received_modal = true;
    await this.gitSendData(item, '0');
    await this.getCouponList();
  }

  async showUsedModal(item: any) {
    this.used_item = item;
    this.is_show_used_modal = true;
    await this.gitSendData(item, '2');
    await this.getCouponList();
  }

  async showQrcodeModal(item: any) {
    this.is_show_qrcode_modal = true;
    await this.fetchPosterQrcode(item.id);
  }

  async fetchPosterQrcode(id: number) {
  const _data =
    ((await this.$axios.get(`${FCAPI}/shang/promotion/coupon/preview/${id}`)) || {}).data || {};
  if (_data.status !== 200) {
    console.error(_data.message);
    return '';
  }
  console.log(_data);
  this.qrcode = _data.data;
  // return _data.data;
}

  showOnlineStatusModal(item: any) {
    this.is_show_status_modal = true;
    this.status_item = item;
    this.status_text = item.status === 1 ? '确认下架' : '确认上架';
  }

  async onChangeOnlineStatus() {
    const res: any = await this.$axios.put(
      `${API.status}/${this.status_item.id}`,
      {
        coupon_id: this.status_item.id,
        status: this.status_item.status === 1 ? 2 : 1,
      },
    );
    if (res.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    this.$message.success('修改成功');
    this.is_show_status_modal = false;
    this.query(this.page);
  }

  // 防止出现 0.1+0.2=0.30000000000000004的情况，整数显示为整数，小数显示两位小数
  numberFormat(num: any) {
    return Number((num / 100).toFixed(2));
  }

  getContent(item: any) {
    let text: string = '';
    if (item.type === 1) {
      text =
        item.threshold === 1
          ? `满${this.numberFormat(item.threshold_money)}减${this.numberFormat(item.money)}券`
          : `减${this.numberFormat(item.money)}券`;
    } else {
      text =
        item.threshold === 1
          ? `满${this.numberFormat(item.threshold_money)}打${item.discount}折券`
          : `${item.discount}折券`;
    }
    return text;
  }

  async gitSendData(item: any, status: any) {
    // status: 2已使用，已领取传0
    const send_data: any = {
      coupon_id: item.id,
      status,
      limit: 5,
    };
    this.send_data = send_data;
  }

  async getCouponList(page: number = 1) {
    this.send_data.current = page;
    const res: any = await this.$axios.get(API.coupon, {
      params: this.send_data,
    });
    if (res.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    if (this.send_data.status === '0') {
      this.received_data = res.data.data || {};
    } else {
      this.used_data = res.data.data || {};
    }
  }

  exportData() {
    this.send_data.is_export = 1;
    const params = this.send_data;
    let url = '';
    url = `${API.coupon}?`;
    for (const key in params) {
      if (key && params[key]) {
        url += `&${key}=${params[key]}`;
      }
    }
    window.location.href = url;
  }

  async query(page: number = 1) {
    const send_data: any = {
      name: this.form.name,
      type: this.form.type,
      status: this.form.status,
      current: page,
      limit: 20,
    };
    const res: any = await this.$axios.get(API.query, {
      params: send_data,
    });
    if (res.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    this.page = page;
    this.table_data = res.data.data || {};
  }

  async created() {
    await this.query();
  }
}
